module.exports = __webpack_public_path__ + "static/media/slider_nav.345221a0.jpg";